import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import type { AbsorberInputs, AbsorberOutputs, AbsorberParams, AbsorberState } from './types';

/** Nasadkali absorber (Kremser / NTU–HTU) — UnitModel. */
export const absorber: UnitModel<
  AbsorberParams,
  AbsorberInputs,
  AbsorberState,
  AbsorberOutputs,
  AbsorberOutputs
> = {
  id: 'absorber',
  init: initState,
  step: stepDynamic,
  steady: solveSteady,
};

export * from './types';
export { solveSteady, equilibriumSlope } from './steady';
export { initState, stepDynamic } from './dynamic';
export * from './kremser';
export * from './hydraulics';
